import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import { TRealtor } from '../../models/realtor';
import { Approval } from '../Approval';
import { SuperAgentStar } from '../SuperAgent';
import { IModerationInfo } from '../../models/agent';

import * as styles from './styles.css';

export interface INameProps {
  name: TRealtor['name'];
  moderationInfo?: IModerationInfo | null;
}

export const Name = (props: INameProps) => {
  const { name, moderationInfo } = props;
  const qualityLevelInfo = moderationInfo?.qualityLevelInfo;

  return (
    <div className={styles['name-container']}>
      <div className={styles['title']}>
        <span className={styles['agent-name']}>
          <ArticleHeading1>
            <span className={styles['name']}>{name}</span>
            <span className={styles['badges']}>{qualityLevelInfo?.showSuperAgent && <SuperAgentStar size={24} />}</span>
          </ArticleHeading1>
        </span>

        <Approval moderationInfo={moderationInfo} />
      </div>
    </div>
  );
};
